<button mat-button (click)="back()">
  <span class="spt-button-content">
    <mat-icon>chevron_left</mat-icon> Back &nbsp;
    <!--    <ng-content></ng-content>-->
    <span class="header-spacer"></span>
  </span>
</button>
